export default "__VITE_ASSET__CRBTCJrX__"